<template>
    <div class="select2-wrapper">
        <input type="text" ref="input" />
    </div>
</template>

<script>
import $ from 'jquery';
import 'select2';
import 'select2/select2.css';
import 'select2/select2_locale_cs.js';

export default {
    props: ['value', 'options', 'disabled'],
    mounted() {
        if (this.options.delay > 0) {
            let query = this.options.query;
            let timer;
            this.options.query = (opt) => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    query(opt);
                }, this.options.delay);
            };
        }

        $(this.$refs.input).select2(this.options);

        const events = ['change', 'selecting', 'selected', 'opening', 'open', 'close', 'highlight', 'clearing', 'removing', 'removed', 'loaded', 'focus', 'blur'].map((i) => 'select2-' + i);

        $(this.$refs.input).on(events.join(' '), (e) => {
            this.$emit(e.type.replace(/^select2-/, ''), e, this.$refs.input);
        });

        $(this.$refs.input).on('change', (e) => {
            this.$emit('input', this.method('data'));
        });

        this.method('data', this.value);
    },
    methods: {
        method(...args) {
            return $(this.$refs.input).select2(...args);
        },
        focus() {
            this.method('focus');
        },
    },
    watch: {
        value() {
            this.method('data', this.value);
        },
        disabled() {
            this.method('enable', !this.disabled);
        },
    },
    destroyed() {
        $(this.$refs.input).off().select2('destroy');
    },
};
</script>

<style lang="scss">
.select2-container {
    display: block;
}
.select2-container-multi .select2-choices {
    display: flex;
    flex-wrap: wrap;
    gap: 0.375rem;
    padding: 0.375rem 0.75rem; /* Same as other form inputs */
    align-items: center;
    border-radius: 0.375rem;
    background: none;
    border-color: #ced4da;
}
.select2-container-multi.select2-container-active .select2-choices {
    box-shadow: none;
}
.select2-wrapper.bs5-is-invalid .select2-container-multi .select2-choices {
    border-color: #dc3545;
}
.select2-container-multi .select2-choices .select2-search-choice {
    box-shadow: none;
    background: #ebebeb;
    margin: 0;
    padding: 0.2em 0.5em 0.2em 1.5em;
    font-size: 90%;
    line-height: 1;
}
.select2-container-multi.select2-container-active {
    box-shadow: 0 0 0 0.25rem rgba(13, 109, 253, 0.25);
    border-radius: 0.375rem;
}
.select2-wrapper.bs5-is-invalid .select2-container-multi.select2-container-active {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 70, 0.25);
}
.select2-container-multi .select2-choices .select2-search-field input {
    display: block;
    margin: 0;
    padding: 0;
    font-size: 100%;
    font-family: inherit;
}
.select2-search-choice-close {
    background: none !important;
    height: 12px;
    top: 50%;
    margin-top: -6px;
}
.select2-search-choice-close::after {
    content: '\00d7';
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 1.6rem;
    line-height: 1;
    color: #000;
}
.select2-result-selectable .select2-match,
.select2-result-unselectable .select2-match {
    background: #ffff9f;
    text-decoration: none;
}
.select2-result-selectable.select2-highlighted .select2-match {
    color: #000;
}
.select2-results .select2-result-label {
    padding: 5px 7px;
}
.select2-drop {
    border-radius: 4px;
    margin-top: 1px;
    border-top: 1px solid #5897fb;
}
</style>
